<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :selectShow="true"
      :show="false"
      :submitData="submitData"
      @success="onSuccess"
    >
      <select-organs
        v-model="formModel.tatSimpleId"
        :needAll="false"
      ></select-organs>
      <el-form-item v-if="formModel.tatSimpleId" label="会员等级">
        <el-select v-model="formModel.levelId" placeholder="请选择">
          <el-option
            v-for="item in levelNameList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="formModel.tatSimpleId" label="伞下会员等级">
        <el-select v-model="formModel.levelId2" placeholder="请选择">
          <el-option
            v-for="item in levelNameList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="伞下会员数量">
        <el-input
          v-model="formModel.number"
          maxlength="20"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </common-top-form>
    <div style="margin-bottom: 15px">
      <span style="font-size: 25px; color: #606266"
        >列表数据总和：{{ listlength }}</span
      >
    </div>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        type="index"
        min-width="80"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="nickName"
        label="会员名称"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.nickName ? doUnicode(scope.row.nickName) : "--" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="手机号"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="auth"
        label="是否认证"
        min-width="130"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.auth ? "已认证" : "未认证" }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="memStatus"
        label="会员状态"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-if="scope.row.memStatus == 0">冻结登录</p>
          <p v-else-if="scope.row.memStatus == 1">启用</p>
          <p v-else-if="scope.row.memStatus == 2">冻结提现</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="realName"
        label="真实姓名"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="totalLowSum"
        label="下级会员数"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="authTime"
        label="认证时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="memupTime"
        label="升级时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        prop="parentPhone"
        label="推荐人"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.parentPhone ? doUnicode(scope.row.parentPhone) : "--" }}
        </template>
      </el-table-column> -->
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import MemberLevelService from "service/MemberLevelService";
import SelectOrgans from "components/business/SelectOrgans";
import MarketService from "service/MarketService";
import PlatoonLicenStatus from "service/constant/PlatoonLicenStatus";
import Regs from "common/conf/Regs";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "memberselecttwo",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  data() {
    return {
      formModel: {
        number: "0",
        levelId: "",
        levelId2: "",
        tatSimpleId: "",
      },
      listlength: "0",
      submitService: MarketService.memberselecttwoList,
      tableData: [],
      levelNameList: [],

      PlatoonLicenStatus: PlatoonLicenStatus,
    };
  },
  mixins: [loadMixin, dialogMixin],
  computed: {
    submitData() {
      const params = {
        tatSimpleId: this.formModel.tatSimpleId,
        levelId: this.formModel.levelId,
        levelId2: this.formModel.levelId2,
        number: this.formModel.number,
      };
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {},
  watch: {
    "formModel.tatSimpleId"(val, oldVal) {
      this.formModel.levelId = "";
      this.formModel.levelId2 = "";
      this.getLevelList(val);
    },
  },
  methods: {
    getLevelList(val) {
      const tatSimpleId = {
        tatSimpleId: val,
      };
      this.doLoad(
        MemberLevelService.select,
        tatSimpleId,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.itemLevelNameList = result.memLevelManageList;
            this.levelNameList = this.itemLevelNameList;
          });
        },
        "信息获取失败"
      );
    },
    // formatterTableStatus(row, column, cellValue, index) {
    //   let value = "";
    //   this.PlatoonLicenStatus.forEach((item) => {
    //     if (item.value == cellValue) {
    //       value = item.label;
    //     }
    //   });
    //   return value ? value : "--";
    // },
    // formatterTableType(row, column, cellValue, index) {
    //   let value = "";
    //   this.PlatoonLicenTypes.forEach((item) => {
    //     if (item.dictKey == cellValue) {
    //       value = item.dictValue;
    //     }
    //   });
    //   return value ? value : "--";
    // },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
        this.listlength = this.tableData.length;
      });
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
        },
        "信息获取失败"
      );
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/MemberSelectTwo.vue